module.exports = __webpack_public_path__ + "static_pc/img/34.9eb6602a.png";